<template>
  <div id="saveHandWrite">
    <el-dialog
      title="保存板书"
      :visible.sync="show_dialog"
      width="80%"
      :modal-append-to-body="can_click_close"
      :append-to-body="!can_click_close"
      :close-on-click-modal="can_click_close"
      :before-close="handleClose"
    >
      <div class="dialog-content" slot=""></div>
      <div class="hand-write-name">
        <span><i>*</i>板书名称</span>
        <el-input
          v-model="hand_write_name"
          show-word-limit
          maxlength="10"
          placeholder="请输入内容"
          size="small"
          @change="change_write_name"
        ></el-input>
      </div>
      <div class="save-to-position">
        <span>保存至</span>
        <selectCourse
          :isSave="true"
          @selectCourse="selectCourseFun"
          :click-type="click_type"
        ></selectCourse>
      </div>
      <div class="save-to-position">
        <span>授课班级</span>
        <!--学科选择框-->
        <el-select v-model="cur_class_id" placeholder="请选择班级" size="small">
          <el-option
            v-for="(item, index) in class_list"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <!--                <p v-if="cur_class_id.length==0">请选择要分享的班级</p>-->
      </div>
      <div class="dialog-bottom">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="sure_save_canvas" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addFileBord, getClass } from "../indexApi";
// import {} from '@/api/commonApi.js'
import selectCourse from "./selectCourse";
export default {
  props: {
    curImgUrl: {
      type: String,
    },
    bgFileId: {
      type: String,
    },
    canvasSet: {
      type: Object,
    },
    clickNewBord: {
      type: Boolean,
    },
  },
  name: "saveHandWrite",
  components: {
    selectCourse, //选择科目组件
  },
  data() {
    return {
      click_type: 1,
      show_dialog: true, //是否显示对话框
      can_click_close: false, //点击遮罩层关闭
      hand_write_name: "板书1", //板书名称
      select_course: "", //当前选择的课程
      img_doc_uploader_url: "", //图片上传地址
      cur_class_id: "",
      class_list: [],
      select_course_obj: {},
      root_subject_id: "",
    };
  },
  methods: {
    //点击确认按钮
    sure_save_canvas() {
      // if(this.select_course_obj.third_subject_id==''){
      //     this.$message({
      //         message:'请选择详细章节',
      //         type:'warning'
      //     })
      //     return ;
      // }
      if (this.hand_write_name.trim() == "") {
        this.$message({
          message: "请输入板书名称",
          type: "warning",
        });
        return;
      }
      this.dialogVisible = false;
      // let file = this.dataURLtoBlob(this.curImgUrl);
      // this.uploadFile('6',this.dataURLtoBlob(this.curImgUrl),this.img_doc_uploader_url,this.addFileBord)
      this.uploadFile_copy(
        "6",
        this.dataURLtoBlob(this.curImgUrl),
        this.addFileBord,
        false,
        "",
        "898989"
      );
    },
    //保存板书
    addFileBord(data, parmas) {
      // console.log(parmas,787878)

      let bg_file_cdn_id = this.bgFileId;

      if (this.canvasSet.back.toLowerCase().replace(/\s+/g, '') !== 'rgba(255,255,255,0)') {
        bg_file_cdn_id = '';
      }

      addFileBord({
        title: this.hand_write_name,
        // course_id:this.select_course,
        // class_id:sessionStorage.getItem('class'),
        file_cdn_id: data.file_cdn_id,
        bg_file_cdn_id: bg_file_cdn_id || null,
        bg_color: this.canvasSet.back,
        root_subject_id: this.select_course_obj.root_subject_id,
        second_subject_id: this.select_course_obj.second_subject_id,
        third_subject_id: this.select_course_obj.third_subject_id,
        course_id: this.select_course_obj.subject_id
          ? this.select_course_obj.subject_id.id
          : "",
        class_id: this.cur_class_id,
      })
        .then((res) => {
          if (res.errCode == 0) {
            this.$message({
              message: res.msg + "!",
              type: "success",
            });
            // 保存板书flydata事件
            this.$flydata.flydataTrack(112);
            this.show_dialog = false;
            this.$emit("saveBord", {
              show: false,
              is_click: this.clickNewBord,
            });
            // console.log(res.data)
          }else{
            this.$message.error(res.msg);
          }
        })
        .catch((err) => console.log(err));
    },
    change_write_name(val) {
      console.log(val);
    },
    //关闭保存弹窗
    handleClose(done) {
      this.show_dialog = false;
      this.$emit("cloaseSave");
    },
    selectCourseFun(val) {
      this.select_course_obj = _.cloneDeep(val);
      if (this.root_subject_id != val.root_subject_id) {
        this.getClass();
      }
      this.root_subject_id = val.root_subject_id;
    },
    getClass() {
      return getClass({
        root_subject_id:
          this.select_course_obj.root_subject_id ||
          sessionStorage.getItem("root_subject"),
      })
        .then((res) => {
          if (res.errCode == 0) {
            this.class_list = _.cloneDeep(res.data);
            // this.class_list.unshift({
            //     id:'',
            //     name:'全部'
            // })
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  async created() {
    let now_year = new Date().getFullYear().toString();
    let now_month =
      new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : (new Date().getMonth() + 1).toString();
    let now_date =
      new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate().toString();
    let now_time = now_year + now_month + now_date;
    this.hand_write_name = "板书" + now_time;
    await this.getClass();

    if (this.class_list.length > 0) {
      this.cur_class_id = this.class_list[0].id;
    }
  },
  watch: {
    // curImgUrl:{
    //     handler(newVal,oldVal){
    //         console.log(newVal,898989898)
    //     },
    //     deep:true,
    //     immediate: true
    // }
  },
};
</script>

<style scoped lang="scss">
#saveHandWrite {
  /*position: absolute;*/
  /*position: fixed;*/
  /*top:0;*/
  /*left:0;*/
}
.save-to-position {
  margin-bottom: 0.1rem;
  > span {
    display: inline-block;
    width: 1rem;
    font-size: 0.16rem;
    text-align: right;
    padding-right: 0.15rem;
    i {
      vertical-align: middle;
      color: red;
      margin-right: 0.04rem;
    }
  }
  > p {
    display: inline-block;
    color: red;
    margin-left: 0.3rem;
    font-size: 0.14rem;
  }
}
/deep/.el-dialog {
  border-radius: 4px;
  max-width: 9rem;
  min-width: 6rem;
}
/deep/.el-dialog__body {
  padding: 0.3rem;
}
/deep/.el-dialog__header {
  font-weight: 500;
  color: #202020;
  padding: 0.16rem 0.16rem 0 0.3rem;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  font-size: 0.18rem;
  font-weight: bold;
}
.hand-write-name {
  width: 100%;
  margin-bottom: 0.2rem;
  > span {
    display: inline-block;
    width: 1.2rem;
    font-size: 0.16rem;
    text-align: right;
    padding-right: 0.2rem;
    i {
      color: red;
      /*font-size: 0.2rem;*/
      margin-right: 0.03rem;
      vertical-align: middle;
    }
  }
  /deep/.el-input {
    width: 1.8rem;
    /*margin-left:0.2rem ;*/
  }
}
.save-to-position {
  > span {
    display: inline-block;
    width: 1.2rem;
    font-size: 0.16rem;
    text-align: right;
    padding-right: 0.2rem;
  }
}
.dialog-bottom {
  text-align: right;
  padding-top: 0.2rem;
  .el-button {
    height: 0.34rem;
    width: 0.72rem;
    &:last-of-type {
      margin-left: 0.2rem;
    }
  }
}
</style>
